import React, { Fragment } from "react";
import {
  Typography,
  Button,
  Stack
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export default function NoteViewer({ note }) {

  const baseURL = `${process.env.REACT_APP_BASE_URL}/file?bname=`;

  const files = [
    ...(note.attachment ? [note.attachment] : []),
    ...(note.other_doc || [])
  ];

  return (
    <Fragment>
      <Typography sx={{ mb: 1, mt: 1 }}>
        Note: {note.description}
      </Typography>

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Files:
      </Typography>

      <Stack spacing={1}>
        {files.map((file, index) => (
          <Button
            key={index}
            variant="outlined"
            startIcon={<DownloadIcon />}
            href={`${baseURL}${file.url}&download=true`}
            target="_blank"
            download
            sx={{ justifyContent: "flex-start" }}
          >
            {file.filename}
          </Button>
        ))}
      </Stack>

      {note.recording_link && (
        <>
          <Typography sx={{ mt: 2 }}>
            Recording
          </Typography>

          <Button
            variant="contained"
            href={note.recording_link}
            target="_blank"
            sx={{
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'secondary.main',
                boxShadow: 'none'
              },
              mb: 2
            }}
          >
            Open Recording
          </Button>
        </>
      )}
    </Fragment>
  );
}